import { render, staticRenderFns } from "./ButacasAnexoComponent.vue?vue&type=template&id=a08a847e"
import script from "./ButacasAnexoComponent.vue?vue&type=script&lang=js"
export * from "./ButacasAnexoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports